"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.isPair = isPair;
exports.isPairValue = isPairValue;
exports.isPairsArray = isPairsArray;
exports.mergePairs = mergePairs;
var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/index-of"));
var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/array/is-array"));
var _every = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/every"));
var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/slice"));
var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/reduce"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/for-each"));
var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/find"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/concat"));
var _last2 = _interopRequireDefault(require("lodash/last"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
const VALID_PAIR_VALUE_TYPES = ['boolean', 'number', 'string', 'undefined'];

/**
 * Checks to see if the value of a pair is a primitive or null
 * @param  {Object|String|Number|String|Undefined}  value The value to check
 * @return {Boolean}                                      True if the value is a valid pair value
 */
function isPairValue(value) {
  return (0, _indexOf.default)(VALID_PAIR_VALUE_TYPES).call(VALID_PAIR_VALUE_TYPES, typeof value) > -1 || value === null;
}

/**
 * Checks to see if the argument is a pair. Returns true if it is a pair.
 * @param  {Object}  pair The pair to check
 * @return {Boolean}
 */
function isPair(pair) {
  if (!pair || typeof pair !== 'object' || !('name' in pair) || !('value' in pair)) {
    return false;
  }
  if ((0, _isArray.default)(pair.value)) {
    var _context;
    return isPairsArray(pair.value) || (0, _every.default)(_context = pair.value).call(_context, item => isPairValue(item));
  }
  return isPairValue(pair.value);
}

/**
 * Checks to see if the argument is a pair array. Returns true if it is a pairs array.
 * @param  {Object}  pairsArray The pairsArray to check
 * @return {Boolean}
 */
function isPairsArray(pairsArray) {
  return (0, _isArray.default)(pairsArray) && (0, _every.default)(pairsArray).call(pairsArray, isPair);
}

/**
 * Deeply combines arrays of name/value pairs. Array values are concatenated.
 * @param  {...Object} args Array of name/value pairs
 * @param  {Boolean}   deep True if pairs with the same name should be combined
 * @return {Object}         Combined array of name/value pairs
 */
function mergePairs(...args) {
  const result = [];
  const deep = (0, _last2.default)(args) === true;
  const sources = typeof (0, _last2.default)(args) === 'boolean' ? (0, _slice.default)(args).call(args, 0, -1) : args;
  return (0, _reduce.default)(sources).call(sources, (memo, source) => {
    (0, _forEach.default)(source).call(source, pair => {
      const {
        name,
        value
      } = pair;
      const matchingPair = (0, _find.default)(memo).call(memo, item => item.name === name);
      if (matchingPair) {
        if (isPairsArray(value) && deep) {
          matchingPair.value = mergePairs(matchingPair.value, value, deep);
        } else if (!isPairsArray(value) && (0, _isArray.default)(value)) {
          var _context2;
          matchingPair.value = (0, _concat.default)(_context2 = []).call(_context2, matchingPair.value, value);
        } else {
          matchingPair.value = value;
        }
      } else {
        memo.push((0, _cloneDeep2.default)(pair));
      }
    });
    return memo;
  }, result);
}